import { Icon } from '../../ui/Icon'
import clickLogo from '../../assets/pay/click.jpeg'
import paymeLogo from '../../assets/pay/payme.png'
import uzumLogo from '../../assets/pay/uzum.jpeg'
import type { PayMethod } from './api'

/** Официальные значки приложений оплаты — квадратные, как иконка приложения. */
const LOGO: Partial<Record<PayMethod, string>> = {
  click: clickLogo,
  payme: paymeLogo,
  uzum: uzumLogo,
}

/**
 * Значок способа оплаты: у приложений — их логотип, у карты и оплаты в
 * аптеке — наш значок. Декоративен: способ называет подпись рядом.
 */
export function PayIcon({ code }: { code: PayMethod }) {
  const logo = LOGO[code]
  if (logo) {
    return <img className={`payicon logo ${code}`} src={logo} alt="" aria-hidden="true" />
  }
  return (
    <span className="payicon" aria-hidden="true">
      <Icon name={code === 'pay_at_pharmacy' ? 'i-store' : 'i-card'} size={20} />
    </span>
  )
}
